var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookmarkFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 13,
    viewBox: "0 0 9 13",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.0001C0 1.67461 1.07452 0.600098 2.4 0.600098H6.4C7.72548 0.600098 8.8 1.67461 8.8 3.0001V11.6031C8.8 12.3115 7.9473 12.6704 7.44077 12.1752L5.51846 10.296C4.89669 9.68821 3.90331 9.68821 3.28154 10.296L1.35923 12.1752C0.852697 12.6704 0 12.3115 0 11.6031V3.0001Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkFilled);
export default __webpack_public_path__ + "static/media/bookmark-filled.19426d1f287a3db6fbb9a1102f7f12f8.svg";
export { ForwardRef as ReactComponent };